import React from "react";
import { withStyles } from "@material-ui/core";
import Slider from '@material-ui/core/Slider';
import Cropper from "react-easy-crop";
import Typography from "../Typography";
import Button from "../Button";
import Loader from "../HylyLoader";

const styles = theme => ({
  scaleText: {
    position: "relative",
    height: "50px",
    borderBottom: "1px solid #EEE",
    width: "100%",
    textAlign: "center",
    paddingTop: "15px",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
      paddingLeft: "16px"
    }
  },
  actionButtons: {
    position: "absolute",
    display: "flex",
    bottom: 10,
    right: 10,
    marginTop: "auto",
    marginBottom: "auto"
  }
});

class ImageCropper extends React.Component {
  canvas = {};

  constructor(props) {
    super(props);
    let { dimension_width, dimension_height } = this.props;

    this.state = {
      imageSrc: "",
      crop: { x: 0, y: 0 },
      zoom: 1,
      aspect: dimension_width / dimension_height,
      croppedAreaPixels: "",
      croppedImage: "",
      cropper: true,
      cropSize: { width: dimension_width, height: dimension_height }
    };
  }

  componentDidMount() {
    this.setState({
      imageSrc: this.props.file
    });
  }

  onCropChange = crop => {
    this.setState({ crop });
  };

  onCropComplete = (croppedArea, croppedAreaPixels) => {
    this.setState({
      croppedAreaPixels: croppedAreaPixels
    });
  };

  onZoomChange = (e, zoom) => {
    this.setState({ zoom });
  };

  getCroppedImg = () => {
    var self = this;
    let { dimension_width, dimension_height } = self.props;

    const srcImage = self.state.imageSrc;
    const pixelCrop = self.state.croppedAreaPixels;
    let img = new Image();
    img.src = srcImage;
    const targetX = pixelCrop.x;
    const targetY = pixelCrop.y;
    const targetWidth = pixelCrop.width;
    const targetHeight = pixelCrop.height;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    img.onload = function () {
      canvas.width = dimension_width;
      canvas.height = dimension_height;
      ctx.drawImage(
        img,
        targetX,
        targetY,
        targetWidth,
        targetHeight,
        0,
        0,
        dimension_width,
        dimension_height
      );

      let croppedImage = canvas.toDataURL("image/png");
      self.props.handleUpload(croppedImage);
    };
  };

  handleCancel = () => {
    this.setState({
      cropper: false,
      croppedImage: ""
    });
    this.props.handleCancel();
  };

  render() {
    const { classes, uploading } = this.props;

    if (uploading) return <Loader />;

    return (
      <div className="main-container">
        <div className={classes.scaleText}>
          <Typography type="body1" color="black">
            Scale Image
          </Typography>
          <div className={classes.actionButtons}>
            <Button
              variant="tertiary"
              size="sm"
              onClick={this.handleCancel}
              state={uploading ? "inactive" : "active"}
              color="darkBlack"
            >
              Cancel
            </Button>

            <Button
              variant="primary"
              size="sm"
              onClick={this.getCroppedImg}
              color="hylyBlue"
              state={uploading ? "inactive" : "active"}
            >
              Save
            </Button>
          </div>
        </div>

        <div className="slider-controls">
          <Typography type="body2" color="deepGrey">
            Drag to reposition photo
          </Typography>
          <Slider
            value={this.state.zoom}
            min={1}
            max={2}
            step={0.1}
            aria-labelledby="Zoom"
            onChange={this.onZoomChange}
            classes={{
              container: "slider",
              track: "track",
              thumb: "thumb"
            }}
          />
        </div>
        <div className="crop-section">
          <div className="crop-container">
            <Cropper
              image={this.state.imageSrc}
              crop={this.state.crop}
              zoom={this.state.zoom}
              aspect={this.state.aspect}
              onCropChange={this.onCropChange}
              onCropComplete={this.onCropComplete}
              onZoomChange={this.onZoomChange}
              classes={{
                containerClassName: "img-container",
                imageClassName: "img-crop",
                cropAreaClassName: "img-area"
              }}
              restrictPosition={true}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(ImageCropper);
